import z from 'zod';

//TODO duplicate from apps/web/lib/
const Choices = z
  .array(
    z.object({
      value: z.string(),
      text: z.string(),
    }),
  )
  .describe('Array of choices for a question.');

//TODO duplicate from apps/web/lib/
const Columns = z
  .array(
    z.object({
      name: z.string(),
      title: z.string(),
    }),
  )
  .describe('Array of columns for matrix-type questions.');

//TODO duplicate from apps/web/lib/
const BaseQuestion = z.object({
  type: z
    .enum([
      'rating',
      'dropdown',
      'checkbox',
      'boolean',
      'text',
      'comment',
      'radiogroup',
      'ranking',
      'tagbox',
      'matrix',
      'matrixdropdown',
      'matrixdynamic',
    ])
    .describe('Type of the survey question'),
  name: z.string().describe('Name of the survey element, in snake case'),
  isRequired: z
    .boolean()
    .optional()
    .describe('Indicates if the survey question is required.'),
  title: z.string().describe('The actual survey question'),
  description: z
    .string()
    .optional()
    .describe('Description of the survey question.'),
  isDemographic: z
    .boolean()
    .optional()
    .describe('Indicates if the survey question is a demographic question'),
});

//TODO duplicate from apps/web/lib/
export const RatingQuestion = BaseQuestion.extend({
  type: z.literal('rating'),
  rateCount: z
    .number()
    .optional()
    .describe('Number of rates. if you want 5 stars use 6'),
  rateMin: z.number().optional().describe('Minimum rate value. starts at 0'),
  rateMax: z.number().optional().describe('Maximum rate value.'),
  minRateDescription: z
    .string()
    .optional()
    .describe('Description for the minimum rate.'),
  maxRateDescription: z
    .string()
    .optional()
    .describe('Description for the maximum rate.'),
}).describe('Rating element schema.');

//TODO duplicate from apps/web/lib/
export const DropdownQuestion = BaseQuestion.extend({
  type: z.literal('dropdown'),
  choices: Choices,
}).describe('Dropdown question schema. Used for multiple choice questions');

//TODO duplicate from apps/web/lib/
export const CheckboxQuestion = BaseQuestion.extend({
  type: z.literal('checkbox'),
  choices: Choices,
  hasOther: z
    .boolean()
    .optional()
    .describe('Indicates if the survey question has an "Other" option.'),
  showOtherItem: z
    .boolean()
    .optional()
    .describe('Indicates if the survey question has an "Other" option.'),
  otherText: z.string().optional().describe('Text for the "Other" option.'),
  otherPlaceholder: z
    .string()
    .optional()
    .describe('Placeholder for the "Other" option.'),
}).describe('Checkbox question schema. Used for multiple choice questions.');

//TODO duplicate from apps/web/lib/
export const BooleanQuestion = BaseQuestion.extend({
  type: z.literal('boolean'),
  labelTrue: z
    .string()
    .optional()
    .describe(
      "Label for the true option. If not set, the default label is 'Yes'",
    ),
  labelFalse: z
    .string()
    .optional()
    .describe(
      "Label for the false option. If not set, the default label is 'No'",
    ),
}).describe('Boolean question question schema. Used for yes/no questions.');

//TODO duplicate from apps/web/lib/
export const TextQuestion = BaseQuestion.extend({
  type: z.literal('text'),
  inputType: z
    .enum(['text', 'number'])
    .optional()
    .describe("Type of the input. Can only be 'text' or 'number'"),
}).describe('Text element schema. Used for open ended questions.');

//TODO duplicate from apps/web/lib/
export const CommentQuestion = BaseQuestion.extend({
  type: z.literal('comment'),
}).describe('Comment element schema. Used for open ended questions.');

//TODO duplicate from apps/web/lib/
export const RadioGroupQuestion = BaseQuestion.extend({
  type: z.literal('radiogroup'),
  choices: Choices,
  hasOther: z
    .boolean()
    .optional()
    .describe('Indicates if the survey question has an "Other" option.'),
  showOtherItem: z
    .boolean()
    .optional()
    .describe('Indicates if the survey question has an "Other" option.'),
  otherText: z.string().optional().describe('Text for the "Other" option.'),
  otherPlaceholder: z
    .string()
    .optional()
    .describe('Placeholder for the "Other" option.'),
}).describe('Radiogroup question schema.');

//TODO duplicate from apps/web/lib/
export const RankingQuestion = BaseQuestion.extend({
  type: z.literal('ranking'),
  choices: Choices,
}).describe('Ranking question schema');

//TODO duplicate from apps/web/lib/
export const TagboxQuestion = BaseQuestion.extend({
  type: z.literal('tagbox'),
  choices: Choices,
}).describe('tagbox question schema');

//TODO duplicate from apps/web/lib/
export const MatrixQuestion = BaseQuestion.extend({
  type: z.literal('matrix'),
  cellType: z
    .enum(['radiogroup', 'checkbox'])
    .optional()
    .describe('Cell type used to render matrix cells.'),
  rows: Choices.optional().describe('Array of row statements for the matrix.'),
  columns: Choices.optional().describe(
    'Array of column options for the matrix.',
  ),
}).describe(
  'Matrix question schema supporting single-select (radiogroup) and multi-select (checkbox).',
);
//TODO duplicate from apps/web/lib/
export const MatrixDropdownQuestion = BaseQuestion.extend({
  type: z.literal('matrixdropdown'),
  cellType: z
    .enum(['dropdown', 'text'])
    .optional()
    .describe('Cell type used to render matrix cells.'),
  rows: Choices.optional().describe(
    'Array of row statements for the matrix dropdown.',
  ),
  columns: Columns.optional().describe(
    'Array of column options (used as column headers).',
  ),
  placeholder: z
    .string()
    .optional()
    .describe('Placeholder text within input field'),
  choices: Choices.optional().describe(
    'Choices available in each dropdown cell.',
  ),
}).describe(
  'Matrix dropdown schema (Multiple-Select Matrix with dropdowns per cell).',
);

//TODO duplicate from apps/web/lib/
export const MatrixDynamicQuestion = BaseQuestion.extend({
  type: z.literal('matrixdynamic'),
  cellType: z
    .enum(['dropdown', 'text'])
    .optional()
    .describe('Cell type used to render matrix cells.'),
  columns: Columns.optional().describe(
    'Array of column options (used as column headers).',
  ),
  placeholder: z
    .string()
    .optional()
    .describe('Placeholder text within input field'),
  choices: Choices.optional().describe(
    'Choices available in each dropdown cell.',
  ),
}).describe(
  'Matrix dynamic schema (Multiple-Select Matrix with dynamic dropdowns per cell).',
);

//TODO duplicate from apps/web/lib/
export const SurveyQuestion = z
  .union([
    RatingQuestion,
    DropdownQuestion,
    CheckboxQuestion,
    BooleanQuestion,
    TextQuestion,
    CommentQuestion,
    RadioGroupQuestion,
    RankingQuestion,
    TagboxQuestion,
    MatrixQuestion,
    MatrixDropdownQuestion,
    MatrixDynamicQuestion,
  ])
  .describe(
    'Union of all possible survey page elements. Choose the best suiting type for the survey question. Try to avoid using text and comment as much as you can.',
  );
